import type { AgreementItem, NavItem } from "@/types/blocks/base";

export const normalizeLandingUrl = (url?: string) => {
  if (!url) {
    return url;
  }

  if (url === "#pricing" || url.endsWith("/#pricing")) {
    return "/pricing";
  }

  let normalized = url;

  if (normalized === "#feature" || normalized.endsWith("/#feature")) {
    normalized = normalized.replace(/#feature$/, "#features");
  }

  if (normalized.includes("/listings")) {
    normalized = normalized.replace("/listings", "/marketplace");
  }

  return normalized;
};

const normalizeNavItem = (item: NavItem): NavItem => ({
  ...item,
  url: normalizeLandingUrl(item.url),
  children: item.children?.map(normalizeNavItem),
});

export const normalizeNavItems = (items?: NavItem[]) =>
  (items ?? []).map(normalizeNavItem);

export const normalizeAgreementItems = (items?: AgreementItem[]) =>
  (items ?? []).map((item) => ({
    ...item,
    url: normalizeLandingUrl(item.url),
  }));
